/**
 * Coaching (staff coaching loop, plan 2026-11-02 "Running the team for him"):
 * each person's weekly report card from their own calls, this week's one
 * habit, "I disagree"; for office leads the team list, the review queue,
 * monthly calibration, escalations and praise, and the profile links and
 * Friday email switch. The morning note lives on Home
 * (app/home/CoachingHuddleStrip.tsx). API: `/v1/coaching`.
 */
import { defineManifest } from '@velora/contracts';
import { COACHING_ENTITY } from '@velora/contracts/coaching';
import { defineWebModule } from '../../app/module.js';

export default defineWebModule({
  manifest: defineManifest({
    id: 'coaching',
    title: 'Coaching',
    version: '0.1.0',
    owner: 'WP5-COACHING',
    entitlementKey: null,
    permissions: ['hr.self', 'hr.view', 'hr.manage', 'patient.view', 'money.view'],
    routes: [
      {
        id: 'coaching',
        path: '/coaching',
        title: 'Coaching',
        officeScope: 'location-or-all',
        permission: 'hr.self',
      },
    ],
    nav: [
      {
        label: 'Coaching',
        group: 'operations',
        routeId: 'coaching',
        icon: 'trending-up',
        order: 45,
        permission: 'hr.self',
      },
    ],
    commands: [
      {
        id: 'coaching.open',
        title: 'Coaching: my report card',
        keywords: [
          'coaching',
          'report card',
          'habit',
          'my calls',
          'grades',
          'disagree',
          'calibration',
        ],
        routeId: 'coaching',
        permission: 'hr.self',
      },
    ],
    sseEntityKeys: [COACHING_ENTITY],
    phiReadPoints: ['coaching.clip', 'coaching.huddle', 'coaching.disputes', 'coaching.tone'],
  }),
  pages: {
    coaching: () => import('./CoachingPage.js'),
  },
});
